import { Button, Icon, Typography } from "@storoey/sui";
import { onCleanup } from "solid-js";
import { formatRelativeDate } from "../../utils/format-relative-date";
import styles from "./PhotoViewer.module.scss";

export const PhotoViewer = (props: {
  file: File;
  date: Date;
  onDelete: () => void;
  onClick: (src: string) => void;
}) => {
  const photoUrl = URL.createObjectURL(props.file);
  const relativeDate = formatRelativeDate(props.date);

  onCleanup(() => {
    if (photoUrl) {
      URL.revokeObjectURL(photoUrl);
    }
  });

  return (
    <div class={styles["container"]}>
      <Typography variant="label">{relativeDate}</Typography>
      <div class={styles["content"]}>
        <button
          type="button"
          class={styles["image-button"]}
          onclick={() => props.onClick(photoUrl)}
        >
          <img src={photoUrl} class={styles["image"]} />
        </button>

        <Button
          leftIcon={<Icon>delete</Icon>}
          color="red"
          onClick={props.onDelete}
        ></Button>
      </div>
    </div>
  );
};
